import React from 'react';

import { arrow } from '../assets';
import { projects } from '../constants/projects';

const Projects = () => (
  <section className="pb-[60px]" id="projects">
    <div className="wrapper">
      <div className="section-title section-title3 pb-[40px] dark:before:bg-primaryOrange/25">
        <h2 className="relative text-[32px] md:text-[40px] font-extrabold md:font-bold text-primaryBlack dark:text-white">
          Featured Projects
        </h2>
      </div>
      {projects.map((project, index) => (
        <div
          key={index}
          className={`${project.style} max-w-[1250px] min-h-[415px] w-full rounded-[20px] 
          md:rounded-3xl mb-[42px] p-9 gap-3`}
        >
          <div>
            <h3 className="text-white text-[28px] md:text-[40px] font-bold leading-[40px] md:leading-[60px]">
              {project.name}
            </h3>
            <div className="flex self-start gap-3 mb-6 md:mb-[60px]">
              <div className="max-w-[500px] py-[20px] text-left rounded-md text-white font-medium text-xs md:text-sm">
                <p className="leading-6">{project.text}</p>
              </div>
            </div>

            <div className="flex self-start">
              <a
                className="group flex items-center text-white text-base font-bold mb-[30px] md:mb-0"
                href={`/case-study/${project.id}`}
              >
                See Detail Project
                <img
                  className="ml-5 w-9 group-hover:w-[60px] transition-all duration-300"
                  src={arrow}
                  alt="arrow"
                />
              </a>
            </div>
          </div>
          <img
            src={project.image}
            alt="project"
            className="max-w-[250px] lg:max-w-[400px]"
          />
        </div>
      ))}
    </div>
  </section>
);

export default Projects;
